// extracted by mini-css-extract-plugin
export default {"LoadingError":"loadingError_LoadingError__zHitG","content":"loadingError_content__9GLlC","message":"loadingError_message__eSa2q"};